/**
 * 商品一覧カード(.ak-product-card.has-hover-image)のホバー時画像切り替え。
 * ホバー(mouseenter)のたびに .ak-product-card__media-img を次の1枚へ進めて .is-active
 * に切り替える。最後まで進んだら1枚目に戻る。mouseleaveでは表示を維持し、何もしない。
 */
(function () {
  function setup(card) {
    var images = Array.prototype.slice.call(card.querySelectorAll('.ak-product-card__media-img'));
    if (images.length < 2) return;

    var index = 0;

    function activate(i) {
      images.forEach(function (img, idx) {
        img.classList.toggle('is-active', idx === i);
      });
    }

    card.addEventListener('mouseenter', function () {
      index = (index + 1) % images.length;
      activate(index);
    });
  }

  var cards = document.querySelectorAll('.ak-product-card.has-hover-image');
  Array.prototype.forEach.call(cards, setup);
})();
